import { useUserStore } from "~/stores/userstore";
import { useCompanyStore } from "~/stores/companystore";
import { useDevicesStore } from "~/stores/devicesstore";
import { useCompanyAddressStore } from "~/stores/companyaddressstore";
import { useCompanyMembersStore } from "~/stores/companymembersstore";

export function useCompanyLoader() {
  const userStore = useUserStore();
  const companyStore = useCompanyStore();
  const companyAddressStore = useCompanyAddressStore();
  const companyMembersStore = useCompanyMembersStore();
  const devicesStore = useDevicesStore();
  const developerCompanyStore = useDeveloperCompanyStore();
  const licenseOptionsStore = useLicenseOptionsStore();

  // reactively load company whenever company_id changes
  watch(
    () => userStore.authUser?.companyId,
    async (companyId) => {
      console.debug("useCompanyLoader: companyId changed to ", companyId);
      if (!companyId) {
        companyStore.clear();
        companyMembersStore.clear();
        companyAddressStore.clear();
        developerCompanyStore.clear();
        licenseOptionsStore.clear();
      } else {
        await companyStore.loadUserCompany(companyId);
        await companyMembersStore.loadAllCompanyMembers(companyId);
        await licenseOptionsStore.loadAllLicenseOptionsForPublishedAppsInCompany(
          companyId,
        );
      }
    },
    { immediate: true }, // run immediately on first use
  );

  watch(
    () => companyStore.userCompany?.legalAddressId,
    async (legalAddressId) => {
      console.debug(
        "useCompanyLoader: legalAddressId changed to ",
        legalAddressId,
      );
      if (!legalAddressId) {
        companyAddressStore.legalAddress = null;
      } else {
        await companyAddressStore.loadCompanyLegalAddress(legalAddressId);
      }
    },
    { immediate: true }, // run immediately on first use
  );

  watch(
    () => companyStore.userCompany?.id,
    async (id) => {
      console.debug("useCompanyLoader: userCompany Id changed to ", id);
      await userStore.loadUserRegistrationStatus();
      await userStore.loadAuthUserRoles();
      devicesStore.clear();
    },
  );
}
